import { promiseActionFactory } from "@teroneko/redux-saga-promise";

import { ICity } from "types/dictionaries.types";
import { createActionTypes } from "utils/store";

export const DICTIONARIES_REDUCER = 'dictionaries'

const DICTIONARIES_ACTIONS = {
  LOAD_CITIES: 'LOAD_CITIES',
  LOAD_RECOMMENDATIONS: 'LOAD_RECOMMENDATIONS',
  LOAD_PROGRAMS: 'LOAD_PROGRAMS',
  LOAD_STOCKS: 'LOAD_STOCKS',
};

const actionTypes = createActionTypes(DICTIONARIES_REDUCER, DICTIONARIES_ACTIONS)

export const loadCitiesAction = promiseActionFactory<ICity[]>().create(actionTypes.LOAD_CITIES)
